module.exports = __webpack_public_path__ + "img/icon-win-coin.e364d080.svg";